<label class="radio"
       [class._disabled]="disabled">

    <input type="radio"
           [value]="value"
           [ngModel]="checked"
           (ngModelChange)="onCheckedChange($event)"
           [disabled]="disabled"
           [name]="name"
    >

    <span class="radio-skin"></span>

    <span class="radio-label" *ngIf="label">
        {{label}}
    </span>
</label>
